<template>
  <div class="bg">

    <div class="content">
        <!-- <img src="/static/img/footer/tel.png"/> -->
        <ul class="telCon">
          <p class="tel">咨询热线：400-168-6606</p>
          <p class="time">（周一至周日：7:00 - 24:00）</p>
        </ul>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'homeTel'
  }
</script>

<style scoped>
  div.bg {
    width: 1100px;
    margin: auto;
    display: flex;
    background-color: rgb(242, 242, 242);

  }
  div.content {
    margin:auto;
    display: block;
  }
  div.content ul.telCon{
    margin: 26px auto 0;
    width: 260px;
    padding-left: 68px;
    background: url('/static/img/footer/tel.png') no-repeat top left;
    background-size: 50px 46px; 
  }
  div.content ul.telCon p{
    width: 200px;
    font-size: 14px;
    font-weight: bold;
  }
  

  p {
    color: rgb(73,73,73);
    text-align: center;
    margin: 0;
    padding: 0;
    padding-top: 3px;
  }
  p.tel {
    font-size: 14px;
  }
  p.time {
    font-size: 14px;
  }
  .tel-img {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// HomeTel.vue?0286f7cf